import { useTranslation } from "react-i18next"

import type { HostedAgentMemoryMode } from "@/api/client/hosted-agents"

import { Badge } from "@/components/ui/badge"

type MemoryModeBadgeProps = {
  mode: HostedAgentMemoryMode
  className?: string
}

/**
 * B6 memory-mode chip: "open" = team agent with shared threads, "personal" =
 * threads private to each user. Informational, so secondary/outline — never
 * primary (DESIGN.md: orange is CTA-only). Badge is `rounded-md` per the
 * radius rule (`rounded-full` is reserved for avatars/status dots).
 */
export function MemoryModeBadge({ mode, className }: MemoryModeBadgeProps) {
  const { t } = useTranslation()
  return (
    <Badge className={className} variant={mode === "open" ? "secondary" : "outline"}>
      {mode === "open" ? t("agents.memoryMode.open") : t("agents.memoryMode.personal")}
    </Badge>
  )
}
